import React, { act, useEffect, useRef, useState } from 'react';
import './courseDemoLectures.css'
import C2wCircleHightlightCrd from '../../../../common/C2wHome/courseDetails/circleHightlightCrd';
import ReactPlayer from 'react-player';
import { useDispatch, useSelector } from 'react-redux';
import { setActiveObj } from '../../../../C2wStore/actions';

function C2wCourseDemoLectures({ courseData }) {
    const [elementWidth, setElementWidth] = useState(0);
    // const [activeObj, setActiveObj] = useState(null);
    const [videosSrc, setVideosSrc] = useState([]);
    const dispatch = useDispatch();
    const activeObj = useSelector((state) => state.data.activeObj);
    console.log(activeObj)
    /**
     * @hook useffect
     * @author Vishal Lohbande
     * @description Monitors changes to `courseData` and initializes video sources:
     * - If `videoLinkArray` contains more than one video, sets the first video's `src` as the active source (`activeSrc`).
     * - Stores the remaining videos in `videosSrc` for further use.
     * - Logs the first video source to the console for debugging.
     * @dependencies
     * - Runs whenever `courseData` changes.
     * 
     * Usage:
     * Used for setting up the main and additional video sources for the course video player component.
     * @updated by govind dindewad
    * @date 22-05-2025
    * @updatedTopic active variable set to global and youtube player setup and conditional changing
     */
    // Initial load
    useEffect(() => {
        if (courseData?.videoLinkArray?.length > 0 && elementWidth > 620) {
            const first = courseData.videoLinkArray[0];
            dispatch(setActiveObj(first));
            
        }
    }, [courseData]);

    const handleVideoClick = (index) => {
        dispatch(setActiveObj(courseData?.videoLinkArray[index]));
    };


    const [showPlayer, setShowPlayer] = useState(false)
    useEffect(() => {
        if (activeObj) {
            setShowPlayer(false); // unmount first
            setTimeout(() => setShowPlayer(true), 50); // remount after 50ms
        }
    }, [activeObj]);


    const elementRef = useRef(null);


    useEffect(() => {
        if (elementRef.current) {
            // Get the width of the referenced element
            setElementWidth(elementRef.current.offsetWidth);
        }

        const handleResize = () => {
            if (elementRef.current) {
                setElementWidth(elementRef.current.offsetWidth);
            }
        };

        // Add resize event listener
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    const renderVideoPlayer = (activeObj) => {
        if (!activeObj?.videoSrc) return null;
        return (
            <>
                <iframe 
                width="100%" 
                height="100%" 
                src={`${activeObj?.videoSrc}?autoplay=1&mute=1&rel=0`} 
                title="YouTube video player" 
                frameborder="0" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                referrerpolicy="strict-origin-when-cross-origin" pl allowfullscreen></iframe>
            </>
        );
    };
    return (
        courseData?.videoLinkArray !== null ? (
            <div className='C2wCourseDemoLectures_ctn' ref={elementRef}>
                <div className='C2wCoureseDetailComponentHeading_ctn'>
                    <div className='heading'>
                        {`${'Demo '} `}
                        <span className='headingSpan'>{`${'Lectures'}`}</span>
                    </div>
                </div>
                <div className='C2wCourseDemoLectures_crd_hld'>
                    {courseData && courseData?.lectureCountArray.map((obj, index) => (
                        <C2wCircleHightlightCrd obj={obj} />
                    ))}
                </div>
                <div className='C2wCourseDemoLecturesVideos_hld_ctn'>{elementWidth > 620 ?

                    <div className='C2wDemoLecturevideoPlayer'>

                        {showPlayer &&

                            <>
                                {renderVideoPlayer(activeObj)}
                            </>
                        }
                    </div> : null}

                    <div className='C2wDemoLecturevideosList_ctn'>
                        {courseData && courseData?.videoLinkArray?.map((obj, index) => (
                            <div className='C2wDemoLecturevideosList_crd' style={{
                                backgroundImage: `url(/assets/images/courseDetails/${obj?.thumbnail})`
                            }}
                                onClick={() => {
                                    if (activeObj?.videoSrc === obj?.videoSrc) {
                                        return
                                    }
                                    handleVideoClick(index)
                                }}>
                                <div className='listPlayBtnDiv'>
                                    <svg width="25" height="32" viewBox="0 0 25 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M-0.00292969 1.97483C-0.00292969 0.536347 1.58843 -0.332454 2.79845 0.445417L23.9816 14.0632C25.0949 14.7789 25.0949 16.4063 23.9816 17.122L2.79845 30.7397C1.58843 31.5176 -0.00292969 30.6488 -0.00292969 29.2103V1.97483Z" fill="#05A5FF" />
                                    </svg>
                                </div>
                                {activeObj?.videoSrc === obj?.videoSrc ?
                                    <div className='INCSUBDemoLecture_crd_playing'>
                                        Playing...</div> : null
                                }
                            </div>))}
                    </div>

                </div>
                <>{activeObj?.videoSrc && elementWidth < 621 ? <div className='C2w_video_show_popup_container'>
                    <div className='C2wDemoLecturevideoPlayer mobile'>
                         <div onClick={()=>{
                            dispatch(setActiveObj(null))
                         }}><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
                        <path d="M18 6L6 18" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M6 6L18 18" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg></div>
                        {showPlayer &&

                            <>
                                {renderVideoPlayer(activeObj)}
                            </>
                        }
                    </div>
                </div> : null}</>
            </div>
        ) : (null)
    )
}

export default C2wCourseDemoLectures
